import React, { Component } from 'react'
import {arrayOfTextsCorona, arrayOfTextsNorwegian, choose, chooseNew} from './StringText'
import './Typing.css';

const startText = choose(arrayOfTextsNorwegian);

class Typing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullText: startText,
      text: startText.split(""),
      currentWord: startText.split(" ")[0],
      currentWrittenWord: "",
      previousLetter: " ",
      previousWrittenLetters: "  ",
      currentIndex: 0,
      lettersRemaining:  startText.length
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleErase = this.handleErase.bind(this);
    this.handleClickNew = this.handleClickNew.bind(this);
    this.handleClickAgain = this.handleClickAgain.bind(this);
  }

  handleErase(evt) {
    console.log(this.state.previousWrittenLetters, this.state.previousLetter)
    if (evt.key == "Backspace" && this.state.previousLetter !== " " && this.state.currentIndex > 0 && this.state.previousLetter === this.state.previousWrittenLetters[0]) {
      this.setState(prevState => {
        return {
          text: [prevState.previousLetter, ...prevState.text],
          previousLetter: prevState.fullText[prevState.currentIndex - 2],
          currentIndex: Math.max(prevState.currentIndex - 1, 0)
        }
      })
    }
  }
  
  handleChange(evt) {
    const lastValue = evt.target.value[evt.target.value.length - 1];
    if (lastValue === " " && lastValue === this.state.text[0] && this.state.currentWrittenWord == this.state.currentWord) {
      evt.target.value = ""
      this.setState(prevState => {
        return {
          text: [...prevState.text.slice(1)],
          currentWord: prevState.text.join("").slice(1).split(" ")[0],
          previousLetter: prevState.text[0],
          currentIndex: prevState.currentIndex + 1,
          lettersRemaining: prevState.lettersRemaining - 1
        }
      })
    } 
    
    if (lastValue === this.state.text[0] && lastValue != " " && evt.target.value == this.state.currentWord.slice(0, this.state.currentWrittenWord.length + 1)) {
      this.setState(prevState => {
        return {
          text: [...prevState.text.slice(1)],
          previousLetter: prevState.text[0],
          currentIndex: prevState.currentIndex + 1,
          lettersRemaining: prevState.lettersRemaining - 1
        }
      })
    }
    this.setState(prevState =>
        ({
          currentWrittenWord: evt.target.value,
          previousWrittenLetters: prevState.previousWrittenLetters[1] + lastValue
        })
    )
  }

  handleClickAgain(evt) {
    this.setState(
      {
         text: this.state.fullText.split(""),
         currentWord: this.state.fullText.split(" ")[0],
         currentWrittenWord: "",
         lettersRemaining: this.state.fullText.length
      }
    )
  }

  handleClickNew(evt) {
    const newText = chooseNew(arrayOfTextsNorwegian, this.state.fullText)
    this.setState(
      { 
        fullText: newText, 
        text: newText.split(""), 
        currentWord: newText.split(" ")[0],
        currentWrittenWord: "",
        lettersRemaining: newText.length
      }
    )
  }

  render() {
    let displayText = this.state.text.join("");
    if (displayText.length >= 40) {
      displayText = this.state.text.join("").slice(0, 40) + '...'
    } 
    let separator = {
      padding: 10
    }
    return (
      <div className="Typing">
        <h1>Norsk Touch Typing</h1>
        <p>Norsk Touch Typing er en gratis og reklamefri applikasjon der du kan trene på å skrive touch. Vi har hentet sitatene fra språkrådet sin informasjon om norsk språk.</p>

        <div className="DisplayedText">
          {
            displayText.length != 0 ?
            <h3><span className="blinkingCursor">|</span>{displayText}</h3> :
            <div>
            <h2>Gratulerer!</h2>
            <h3>Vil du prøve igjen?</h3>
            </div>
          }
        </div>
        <div className="InputField">
        { displayText.length != 0 &&
          <input type="text" value={this.state.currentWrittenWord} placeholder="Skriv her ..." onKeyUp={this.handleErase} onChange={this.handleChange}/> 
        }
        </div>
        <div className="ButtonContainer">
          <button onClick={this.handleClickAgain}>Prøv Igjen</button>
          { 
            displayText.length != 0 &&
            <h3>Letters Remaining: {this.state.lettersRemaining}</h3>
          }
          <button onClick={this.handleClickNew}>Nytt Sitat</button>
        </div>
      </div>
    )
  }
}

export default Typing;